import { ComplianceStatusEnum } from '../../../shared/types/business-functions-workarounds';

export const APPLICATION_TYPES = {
  ENTERPRISE: 'ENTERPRISE',
  LOCATIONS: 'LOCATIONS',
};

export const SUPPORTED_FACTORS = ['R', 'E', 'L', 'C'];

export enum SECTIONS {
  APPLICATION_REVENUE_MAPPING = 'Application Revenue Mapping',
  BUSINESS_FUNCTION_TAGGING = 'Business Function Tagging',
  QUALITATIVE_FACTORS = 'Qualitative Factors',
}

const enum WORKAROUNDS_SECTIONS {
  PROCESS_AREAS_AND_PROCESSES = 'Process Areas & Processes',
  BUSINESS_FUNCTIONS = 'Business Function Workarounds',
  QUALITATIVE_FACTORS = 'Qualitative Factors Workarounds',
}

export enum LOCATION_LEVEL_SECTIONS {
  APPLICATION_REVENUE_MAPPING = 'Application Revenue Mapping',
  PROCESS_AREA_AND_PROCESS_TAGGING = 'Process Area & Process Tagging',
  BUSINESS_FUNCTION_TAGGING = 'Business Function Tagging',
  QUALITATIVE_FACTORS = 'Qualitative Factors',
}

export const statusToColor = {
  [ComplianceStatusEnum.COMPLIANT]: 'green',
  [ComplianceStatusEnum.PARTIALLY_COMPLIANT]: 'yellow',
  [ComplianceStatusEnum.NON_COMPLIANT]: 'red',
};

export const FeatureName: { [key in LOCATION_LEVEL_SECTIONS]: string } = {
  [LOCATION_LEVEL_SECTIONS.APPLICATION_REVENUE_MAPPING]:
    'APPLICATION_REVENUE_MAPPING',
  [LOCATION_LEVEL_SECTIONS.PROCESS_AREA_AND_PROCESS_TAGGING]:
    'PROCESS_AREA_AND_PROCESS_TAGGING',
  [LOCATION_LEVEL_SECTIONS.BUSINESS_FUNCTION_TAGGING]:
    'BUSINESS_FUNCTION_TAGGING',
  [LOCATION_LEVEL_SECTIONS.QUALITATIVE_FACTORS]: 'QUALITATIVE_FACTORS',
};

export const enterpriseLevelSections = [
  {
    title: SECTIONS.APPLICATION_REVENUE_MAPPING,
    description: 'Financial Importance of Applications',
    reviewLink: '/cyber/enterprise-level/it-applications/selection',
  },
  {
    title: SECTIONS.BUSINESS_FUNCTION_TAGGING,
    description: 'Where Applications are used',
    reviewLink: '/cyber/enterprise-level/business-functions',
  },
  {
    title: SECTIONS.QUALITATIVE_FACTORS,
    description: 'Go Beyond Financial Quantification',
    reviewLink: '/cyber/enterprise-level/qualitative-factors',
  },
];

export const locationLevelSections = [
  {
    id: 1,
    title: LOCATION_LEVEL_SECTIONS.APPLICATION_REVENUE_MAPPING,
    description: 'Financial importance of applications',
    reviewLink: (locationId: string) =>
      `/cyber/location-level/${locationId}/it-applications/selection`,
  },
  {
    id: 2,
    title: LOCATION_LEVEL_SECTIONS.PROCESS_AREA_AND_PROCESS_TAGGING,
    description: 'Operational Technology Mapping',
    reviewLink: (locationId: string) =>
      `/cyber/location-level/${locationId}/process-areas-and-processes`,
  },
  {
    id: 3,
    title: LOCATION_LEVEL_SECTIONS.BUSINESS_FUNCTION_TAGGING,
    description: 'Where Applications are used',
    reviewLink: (locationId: string) =>
      `/cyber/location-level/${locationId}/business-functions`,
  },
  {
    id: 4,
    title: LOCATION_LEVEL_SECTIONS.QUALITATIVE_FACTORS,
    description: 'Go Beyond Financial Quantification',
    reviewLink: (locationId: string) =>
      `/cyber/location-level/${locationId}/qualitative-factors`,
  },
];

export const workaroundsCards = [
  {
    id: 1,
    title: WORKAROUNDS_SECTIONS.BUSINESS_FUNCTIONS,
    description:
      'Capture how business functions can keep operating without applications',
    reviewLink:
      '/cyber/enterprise-level/application-workarounds/business-functions',
    isEnabled: true,
  },
  {
    id: 2,
    title: WORKAROUNDS_SECTIONS.QUALITATIVE_FACTORS,
    description:
      'Capture workarounds for qualitative factors if applications experience a disruption',
    reviewLink: '/cyber/enterprise-level/qualitative-factors/workarounds',
    isEnabled: true,
  },
];

export const locationLevelWorkaroundsCards = [
  {
    id: 1,
    title: WORKAROUNDS_SECTIONS.PROCESS_AREAS_AND_PROCESSES,
    description: 'Keep process areas & processes running',
    reviewLink: (locationUUID: string) =>
      `/cyber/location-level/${locationUUID}/process-areas-and-processes/workarounds`,
    isEnabled: true,
  },
  {
    id: 2,
    title: WORKAROUNDS_SECTIONS.BUSINESS_FUNCTIONS,
    description:
      'Capture how business functions can keep operating without applications',
    reviewLink: (locationId: string) =>
      `/cyber/location-level/${locationId}/business-functions-workarounds`,
    isEnabled: true,
  },
  {
    id: 3,
    title: WORKAROUNDS_SECTIONS.QUALITATIVE_FACTORS,
    description:
      'Capture workarounds for qualitative factors if applications experience a disruption',
    reviewLink: (locationId: string) =>
      `/cyber/location-level/${locationId}/qualitative-factors/workarounds`,
    isEnabled: true,
  },
];

export const ProcessAreaAndTaggingTitle = 'Process Area & Process Tagging';

export const BusinessFunctionTaggingTitle = 'Business Function Tagging';
